/** Lower-case particles that belong to the surname ("de Salis", "Le Mortellec", "van der Berg"). */
const PARTICLES = new Set(["de", "du", "des", "d'", "le", "la", "les", "van", "von", "der", "den", "di", "da", "del", "della", "dos", "el", "al", "ben", "ter"]);

/**
 * "Prénom Nom" out of a registry name, which lists every given name then the surname, sometimes
 * with a usage name in brackets: "VIRGINIE KARINE CHANTAL LE MORTELLEC" → "VIRGINIE LE MORTELLEC",
 * "ARMELLE BLEUNVEN (KERVELLA)" → "ARMELLE BLEUNVEN". Case is kept as stored. A compound first name
 * written with a hyphen ("JEAN-FRANCOIS") is one token, so it stays whole.
 */
export function firstAndLastName(name?: string | null): string {
    const tokens = (name || "").replace(/\([^)]*\)/g, " ").trim().split(/\s+/).filter(Boolean);
    if (tokens.length <= 2) return tokens.join(" ");
    let start = tokens.length - 1;
    while (start > 1 && PARTICLES.has(tokens[start - 1].toLowerCase())) start--;
    return [tokens[0], ...tokens.slice(start)].join(" ");
}

/**
 * The registry shouts ("JEREMY MAUPPIN"): each word capitalised, particles lower-case
 * ("Philippe de Salis"), hyphens and apostrophes kept ("Jean-François", "d'Arc").
 * A name already written in mixed case is left as it is.
 */
export function titleCaseName(name?: string | null): string {
    const text = (name || "").trim();
    if (text !== text.toUpperCase()) return text;
    return text
        .toLowerCase()
        .split(/\s+/)
        .map((word, i) => (i > 0 && PARTICLES.has(word) ? word : word.replace(/(^|[-'’])(\p{L})/gu, (_, sep, l) => sep + l.toUpperCase())))
        .join(" ");
}

/** What a card shows: first given name + surname, readable case. */
export const ownerDisplayName = (name?: string | null): string => titleCaseName(firstAndLastName(name));
